<template>
    <div class="modal" id="myRebookModal">
        <div class="modal-content">
            <div class="row">
                <span class="close">&times;</span>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <h3>{{$t('page.management.booking.source_place')}}</h3>
                    <auto-complete-text-edit :ref="$id('sourcePlace')"
                                             :url="urlPlaces"
                                             :placeholder="placeholderPlaces"
                                             name="storage_place"
                                             v-on:newValue="handleNewPlace"
                                             :key="componentKey"></auto-complete-text-edit>
                    <auto-complete-text-edit :ref="$id('sourceSku')"
                                             :url="urlSkuPlaces"
                                             :placeholder="placeholderSku"
                                             name="sku"
                                             :key="componentKey"
                                             :options="{place: this.sourcePlace}"></auto-complete-text-edit>
                    <input type="text" class="form-control" :ref="$id('sourceAmount')" :placeholder="$t('page.management.booking.enter_quantity')" />
                </div>
                <div class="col-md-6">
                    <h3>{{$t('page.management.booking.dest_place')}}</h3>
                    <auto-complete-text-edit :ref="$id('destPlace')"
                                             :url="urlPlaces"
                                             :placeholder="placeholderPlaces"
                                             name="new_storage_place"
                                             :key="componentKey"></auto-complete-text-edit>
                </div>
            </div>
            <div class="row">
                <div class="col-md-offset-6 col-md-6">
                    <button class="form-control" v-on:click="checkForm">{{$t('page.management.booking.create_rebooking')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Rebook",
        data: function() {
            return {
                sourcePlace: "",
                componentKey: 0,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            }
        },
        props: {
            placeholderSku: String,
            placeholderPlaces: String,
            urlSku: String,
            urlSkuPlaces: String,
            urlPlaces: String,
            action: String,
        },
        methods: {
            handleNewPlace: function (newValue, index) {
                this.sourcePlace = newValue.split(' - ', 1);
                //Vue.set(this.sourcePlace, newValue);
            },
            checkForm: function (e) {
                axios.post('/manage/storage/booking/rebook/create', {
                    headers: {
                        'X-CSRF-TOKEN': this.csrf
                    },
                    sourcePlace: $('input[name^=storage_place]').val().split(' - ', 1),
                    sourceSku: $('input[name^=sku]').val(),
                    quantity: vue.$refs[vue.$id('sourceAmount')].value,
                    destPlace: $('input[name^=new_storage_place]').val().split(' - ', 1),

                }).then(function (response) {
                    alert(trans('page.product.view.product_was_rebooked'));
                    location.reload();
                }).catch(function (error) {
                    let json = error.response.data;
                    let errors = Object.values(json.errors);
                    let errorMsg = json.message;

                    errors.forEach(function (value) {
                        if (value.isArray === true) {
                            value.forEach(function (msg) {
                                errorMsg = errorMsg + '\n' + msg;
                            });
                        } else {
                            errorMsg = errorMsg + '\n' + value;
                        }
                    });

                    alert(errorMsg);
                })
            }
        }

    }
</script>

<style scoped>

</style>